'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

var _time = require('./time');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatDateTime = function formatDateTime(date, time, localeConstants) {
  var timeF = time === _constants.DELIVERY_TIME_DEFAULT ? localeConstants.ASAP : time;
  var dateF = date === _time2.default.localToday() || date === _constants.DELIVERY_DATE_DEFAULT ? localeConstants.TODAY : date;

  return { date: dateF, time: timeF };
};

exports.default = {
  formatDateTime: formatDateTime
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/datetime-formatter.js
// module id = 192
// module chunks = 0